import { Injectable } from "@angular/core";

import { ProductSizeVariant } from "@hermes/api-model-product";
import { isOutOfStock } from "@hermes/fragments/product-utils";
import { AddToCartFacade } from "@hermes/states/add-to-cart";
import { ProductPageFacade, SIZE } from "@hermes/states/product-page";
import { EcomErrorCodes } from "@hermes/utils-generic/constants";

@Injectable()
export class ProductListItemService {
    private static readonly MAX_LOOK_ITEMS = 11;

    constructor(
        private productPageFacade: ProductPageFacade,
        private addToCartFacade: AddToCartFacade,
    ) {}

    public actionsOnSelectedSizeVariantChange(
        variant: ProductSizeVariant,
        position: number,
    ): void {
        this.productPageFacade.selectVariant(SIZE, variant, position);

        if (isOutOfStock(variant.stock)) {
            this.addToCartFacade.addToCartFailure(
                EcomErrorCodes.SIZE_OUT_OF_STOCK,
                position,
            );
        } else {
            this.addToCartFacade.setAddToCartCallToActionsToDefault(position);
        }
    }
}
